/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Forgot_PasswordInputs */

const en_auth_forgot_password = /** @type {(inputs: Auth_Forgot_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forgot password?`)
};

const es_auth_forgot_password = /** @type {(inputs: Auth_Forgot_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Olvidaste tu contraseña?`)
};

const fr_auth_forgot_password = /** @type {(inputs: Auth_Forgot_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mot de passe oublié ?`)
};

const de_auth_forgot_password = /** @type {(inputs: Auth_Forgot_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwort vergessen?`)
};

const ja_auth_forgot_password = /** @type {(inputs: Auth_Forgot_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスワードをお忘れですか？`)
};

const zh_auth_forgot_password = /** @type {(inputs: Auth_Forgot_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`忘记密码？`)
};

const ar_auth_forgot_password = /** @type {(inputs: Auth_Forgot_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هل نسيت كلمة المرور؟`)
};

const id_auth_forgot_password = /** @type {(inputs: Auth_Forgot_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lupa kata sandi?`)
};

const it_auth_forgot_password = /** @type {(inputs: Auth_Forgot_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password dimenticata?`)
};

const ru_auth_forgot_password = /** @type {(inputs: Auth_Forgot_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Забыли пароль?`)
};

const pt_auth_forgot_password = /** @type {(inputs: Auth_Forgot_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esqueceu a senha?`)
};

const ko_auth_forgot_password = /** @type {(inputs: Auth_Forgot_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`비밀번호를 잊으셨나요?`)
};

/**
* | output |
* | --- |
* | "Forgot password?" |
*
* @param {Auth_Forgot_PasswordInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const auth_forgot_password = /** @type {((inputs?: Auth_Forgot_PasswordInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Forgot_PasswordInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_forgot_password(inputs)
	if (locale === "es") return es_auth_forgot_password(inputs)
	if (locale === "fr") return fr_auth_forgot_password(inputs)
	if (locale === "de") return de_auth_forgot_password(inputs)
	if (locale === "ja") return ja_auth_forgot_password(inputs)
	if (locale === "zh") return zh_auth_forgot_password(inputs)
	if (locale === "ar") return ar_auth_forgot_password(inputs)
	if (locale === "id") return id_auth_forgot_password(inputs)
	if (locale === "it") return it_auth_forgot_password(inputs)
	if (locale === "ru") return ru_auth_forgot_password(inputs)
	if (locale === "pt") return pt_auth_forgot_password(inputs)
	return ko_auth_forgot_password(inputs)
});